<template>
  <v-bottom-sheet
    v-model="assetDialog"
    :fullscreen="fullscreen"
    scrollable
    :no-click-animation="true"
    @click:outside="closeSheet"
  >
    <v-sheet :height="bottomsheetSize" style="display:flex;flex-direction:column">

      <div class="ec-list" style="flex:1;overflow:hidden;display:flex;flex-direction:column;border-radius:0">

        <admin-table-subheader
          v-model="search"
          title="Role Assets"
          search
          search-placeholder="Search asset…"
          :refresh-button="true"
          :refresh-loading="loadingRoleAssets"
          :icon-buttons="[
            { icon: fullscreen ? 'mdi-window-restore' : 'mdi-checkbox-blank-outline', title: fullscreen ? 'Restore' : 'Fullscreen', click: () => fullscreen = !fullscreen }
          ]"
          :primary-button="{ label: 'New Asset', icon: 'mdi-plus', click: newAssetDialog }"
          :close-button="true"
          @refresh="fetchAssets"
          @close="closeSheet"
        />

        <div v-if="loadingRoleAssets" class="ec-loading">
          <v-progress-circular indeterminate color="primary" size="32" />
        </div>

        <v-data-table
          v-else
          :headers="headers"
          :items="getRoleAsssets"
          :search="search"
          class="ec-table"
          style="flex:1;overflow:auto"
        >
          <template v-slot:[`item.scopeType`]="{ item }">
            <span v-if="item.scopeType" class="ec-badge ec-badge--purple">{{ item.scopeType }}</span>
            <span v-else class="u-status-pill u-pill--gray">—</span>
          </template>

          <template v-slot:[`item.isBoundSuperAdmin`]="{ item }">
            <span class="u-status-pill" :class="item.isBoundSuperAdmin ? 'u-pill--green' : 'u-pill--gray'">
              <v-icon size="11" style="margin-right:3px">{{ item.isBoundSuperAdmin ? 'mdi-check' : 'mdi-minus' }}</v-icon>
              {{ item.isBoundSuperAdmin ? 'Yes' : 'No' }}
            </span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-menu offset-y content-class="ec-action-menu">
              <template v-slot:activator="{ on }">
                <button class="ec-icon-btn" v-on="on">
                  <v-icon size="16">mdi-dots-horizontal</v-icon>
                </button>
              </template>
              <v-list>
                <v-list-item
                  v-for="(action, idx) in actionButtons"
                  :key="idx"
                  :disabled="action.disabled"
                  @click="action.func(item)"
                >
                  <v-list-item-icon class="mr-2">
                    <v-icon :color="action.color" size="16">{{ action.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title :class="action.color === 'red' ? 'ec-menu-item--danger' : ''">
                      {{ action.actionName }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </div>

      <new-asset
        v-if="showNewAssetDialog"
        :roleAssetDialog="showNewAssetDialog"
        @fetchAssets="fetchAssets"
        @closeRoleAssetDialog="showNewAssetDialog = false"
      />
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import { apiService } from '../../service/api.service'
import NewAsset from './NewAsset.vue'
import AdminTableSubheader from '../shared/AdminTableSubheader.vue'
import { ROLE_ASSETS_ENDPOINT } from '@/service/backend_endpoints/_endpointPaths'

export default {
  components: { NewAsset, AdminTableSubheader },
  props: {
    assetDialog: { type: Boolean, default: true }
  },
  data () {
    return {
      search: '',
      fullscreen: false,
      showNewAssetDialog: false,
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'URL', value: 'url' },
        { text: 'Scope', value: 'scopeType' },
        { text: 'Bound To Superadmin', value: 'isBoundSuperAdmin' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      actionButtons: [
        { icon: 'mdi-pencil-circle-outline', actionName: 'Edit Asset', color: 'grey', func: this.editAsset, disabled: true },
        { icon: 'mdi-delete-outline', actionName: 'Delete Asset', color: 'red', func: this.deleteAsset, disabled: false }
      ]
    }
  },
  created () { this.fetchAssets() },
  computed: {
    ...mapGetters(['getRoleAsssets', 'loadingRoleAssets']),
    bottomsheetSize () {
      switch (this.$vuetify.breakpoint.name) {
        case 'lg': return '70vh'
        case 'xl': return '50vh'
        default: return '100vh'
      }
    }
  },
  methods: {
    newAssetDialog () { this.showNewAssetDialog = true },
    async fetchAssets () { await this.$store.dispatch('getRoleAsssets') },
    editAsset (item) { console.log('edit asset', item) },
    deleteAsset (item) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to delete this asset?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete'
      }).then(async (res) => {
        if (res.value) {
          await apiService.delete(ROLE_ASSETS_ENDPOINT, { data: { id: item.id } })
            .then(() => { this.fetchAssets(); Swal.fire('Deleted!', 'Asset has been deleted.', 'success') })
            .catch(() => Swal.fire('Failed', 'Failed to delete asset, please try again', 'warning'))
        }
      })
    },
    closeSheet () { this.$emit('closeSheet') }
  }
}
</script>
